"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chart = void 0;
/**
 * @desc core
 */
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var core_1 = require("@byted/lightcharts/lib/core");
Object.defineProperty(exports, "Chart", { enumerable: true, get: function () { return core_1.Chart; } });
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
if (core_1.setJSXRenderer) {
    core_1.setJSXRenderer(react_dom_1.default);
}
var ReactLightchartsCore = function (props) {
    var _a = props.option, option = _a === void 0 ? {} : _a, _b = props.style, style = _b === void 0 ? {} : _b, onReady = props.onReady, className = props.className, chartRef = props.chartRef, pixelRatio = props.pixelRatio, _c = props.renderer, renderer = _c === void 0 ? 'canvas' : _c, _d = props.workerEnabled, workerEnabled = _d === void 0 ? false : _d;
    var refDOM = react_1.createRef();
    var refChart = react_1.useRef();
    var domStyle = __assign({ height: '300px' }, style);
    var refPrefProps = react_1.useRef(null);
    react_1.useEffect(function () {
        if (!refChart.current) {
            refChart.current = new core_1.Chart(refDOM.current, { dpr: pixelRatio, renderer: renderer, workerEnabled: workerEnabled });
            if (chartRef) {
                chartRef.current = refChart.current;
            }
            if (typeof onReady === 'function') {
                onReady(refChart.current);
            }
            refChart.current.setOption(option);
        }
        return function () {
            refChart.current.destroy();
            if (chartRef) {
                chartRef.current = null;
            }
            refChart.current = null;
        };
    }, []);
    react_1.useEffect(function () {
        if (refPrefProps.current) {
            var prevProps = refPrefProps.current;
            if (!react_fast_compare_1.default(props.option, prevProps.option)) {
                refChart.current.setOption(props.option);
            }
            if (!react_fast_compare_1.default(props.style, prevProps.style) || !react_fast_compare_1.default(props.className, prevProps.className)) {
                refChart.current.resize();
            }
        }
    });
    react_1.useEffect(function () {
        refPrefProps.current = props;
    });
    return (react_1.default.createElement("div", { ref: refDOM, className: className, style: domStyle }));
};
exports.default = ReactLightchartsCore;
//# sourceMappingURL=core.js.map